import React from 'react';
import { useIntl } from 'react-intl';
import FlyoutModal from '../common/FlyoutModal';
import messages from './messages';
import OrderSummarySteppedWrapper from '../../blocks/Checkout/OrderSummarySteppedWrapper';
import OrderSummary from '../../blocks/Checkout/OrderSummary';
import { OrderSummaryDataSources } from '../../hooks/useOrderDataSource';
import { FLYOUT_MODAL_THEME_TIGHT } from '../common/FlyoutModal/constants';

const MobileOrderSummary = ({
  isOpen= false,
  onClickClose= () => { },
}: {
    isOpen: boolean;
   onClickClose: () => void;
  }) => {
  const { formatMessage } = useIntl();

  return isOpen ? (
        <FlyoutModal
          isVisible={isOpen}
          onCloseModal={() => onClickClose()}
          backButtonLabel={formatMessage(messages.buttonBackLabel)}
          theme={FLYOUT_MODAL_THEME_TIGHT}
        >
          <OrderSummarySteppedWrapper
            dataSource={OrderSummaryDataSources.CART}
            title={formatMessage(messages.title)}
            isMobileOrderSummary
          >
            <OrderSummary
              dataSource={OrderSummaryDataSources.CART}
            />
          </OrderSummarySteppedWrapper>
        </FlyoutModal>
      ) : null}

export default MobileOrderSummary;
